export default {
      id: "liquidity-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#liquidity",
      toString: function () {
        return this.url;
      }
    }